import { useData } from "./DataContext.js";

import ProgressBar from "react-bootstrap/ProgressBar";

const style = { width: "160px", height: "28px" };

export default function ImpactBar (props)
{
    const gData = useData();

    const className = "border border-2 border-dark w-100 ";

    const currentColor = "dark";
    const currentBgColor = "bg-dark";
    const currentStriped = true;

    const missingColor = "secondary";
    const missingTextColor = "text-white";
    const missingStriped = false;
    const impactStriped = false;
    const resultStriped = true;
    
    const halfHeight = "20px";
    const variableMax = gData.content.params.variableMax;

    let currentValue = gData.state.variables[props.variableId].value;
    if (props.type === "result" && gData.state.currentThemeId !== null) currentValue = gData.state.themes[gData.state.currentThemeId].endVariables[props.variableId].value;
    if (currentValue > variableMax) currentValue = variableMax;
    else if (currentValue < -variableMax) currentValue = -variableMax;
    currentValue = (currentValue + variableMax) * 100 / (2 * variableMax);

    let diff = null;
    
    let bar = (<></>);
    
    if (props.type === "state")
    {
	bar = (
	    <ProgressBar className={className + "bg-light"} style={style}>
		<ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
		<ProgressBar variant="light" now={100 - currentValue} key={2} />
	    </ProgressBar>
	);
    }

    else if ((props.type === "result" && gData.state.currentThemeId !== null) || props.type === "inter-result")
    {
	diff = 0;

	if (props.type === "result")
	{
	    let startValue = gData.state.themes[gData.state.currentThemeId].startVariables[props.variableId].value;
	    if (startValue > variableMax) startValue = variableMax;
	    else if (startValue < -variableMax) startValue = -variableMax;
	    startValue = (startValue + variableMax) * 100 / (2 * variableMax);
	    diff = currentValue - startValue;
	}
	
	else if (props.type === "inter-result")
	{
	    if (gData.state.solutions[gData.state.currentSolutionId].applied)
	    {
		const result = gData.state.reports[gData.state.currentSolutionId].result;
		diff = result.variables[props.variableId].realImpact;
		diff = diff * 100 / (2 * variableMax);
		/* if (currentValue + diff > 100) diff = 100 - currentValue;
		   else if (currentValue + diff < 0) diff = currentValue; */
	    }
	}	
	
	if (diff < 0)
	{
	    bar = (
		<ProgressBar className={className + "bg-light"} style={style}>
		    <ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
		    <ProgressBar variant="danger" striped={resultStriped} now={-diff} key={2}/>
		    <ProgressBar variant="light" now={(100 - currentValue + diff)} key={3} />
		</ProgressBar>
	    );
	}

	else if (diff > 0)
	{
	    let displayedValue = diff * 100 / (2 * variableMax);
	    if (displayedValue > 100 - currentValue) displayedValue = 100 - currentValue;

	    bar = (
		<ProgressBar className={className + "bg-light"} style={style}>
		    <ProgressBar variant={currentColor} striped={currentStriped} now={currentValue - diff} key={1} />
		    <ProgressBar variant="success" striped={resultStriped} now={diff} key={2}/>
		    <ProgressBar variant="light" now={100 - currentValue} key={3} />
		</ProgressBar>
	    );
	}

	else {
	    bar = (
		<ProgressBar className={className + "bg-light"} style={style}>
		    <ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
		    <ProgressBar variant="secondary" striped={resultStriped} now={0} key={2}/>
		    <ProgressBar variant="light" now={100 - currentValue} key={3} />
		</ProgressBar>
	    );
	}
    }
    
    else if (props.type === "impact")
    {
	const reportVariable = gData.state.reports[props.solutionId].result.variables[props.variableId];
	if (reportVariable.maxReliability === 0)
	{
	    bar = (
		<ProgressBar className={className + "bg-light"} style={style}>
		    <ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
		    <ProgressBar variant="light" now={100 - currentValue} key={2} />
		</ProgressBar>
	    );
	}

	else if (reportVariable.reliability === 0)
	{
	    bar = (
		<ProgressBar className={className} style={style}>
		    <ProgressBar variant={missingColor} striped={missingStriped} className={missingTextColor} now={100} key={1} label="Données manquantes" />
		</ProgressBar>
	    );
	}

	else if (reportVariable.reliability < reportVariable.maxReliability)
	{
	    bar = (
		<ProgressBar className={className} style={style}>
		    <ProgressBar variant={missingColor} striped={missingStriped} className={missingTextColor} now={100} key={1} label="Données manquantes" />
		</ProgressBar>
	    );
	}

	else {	
	    const estImpact = reportVariable.estPosImpact - reportVariable.estNegImpact;

	    if (estImpact < 0)
	    {
		let displayedValue = -estImpact * 100 / (2 * variableMax);
		if (displayedValue > currentValue) displayedValue = currentValue;
		
		bar = (
		    <ProgressBar className={className + currentBgColor} style={style}>
			<ProgressBar variant={currentColor} striped={currentStriped} now={currentValue - displayedValue} key={1} />
			<ProgressBar variant="danger" striped={impactStriped} now={displayedValue} key={2} style={{ height: halfHeight }} className="m-auto" />
			<ProgressBar variant="light" now={(100 - currentValue)} key={3} />
		    </ProgressBar>
		);
	    }

	    else if (estImpact > 0)
	    {
		let displayedValue = estImpact * 100 / (2 * variableMax);
		if (displayedValue > 100 - currentValue) displayedValue = 100 - currentValue;

		bar = (
		    <ProgressBar className={className + "bg-light"} style={style}>
			<ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
			<ProgressBar variant="success" striped={impactStriped} now={displayedValue} key={2} style={{ height: halfHeight }} className="m-auto" />
			<ProgressBar variant="light" now={100 - (currentValue + displayedValue)} key={3} />
		    </ProgressBar>
		);
	    }

	    else {
		bar = (
		    <ProgressBar className={className + "bg-light"} style={style}>
			<ProgressBar variant={currentColor} striped={currentStriped} now={currentValue} key={1} />
			<ProgressBar variant="light" now={100 - currentValue} key={2} />
		    </ProgressBar>
		);
	    }
	}
    }
    
    else return (<></>);

    return (
	<div className="w-100 d-flex align-items-center gap-0">
	    {bar}
	    <div className="fs-6 fw-medium text-end" style={{ width: "50px" }}>{Math.round(currentValue)}%</div>
	    {(diff !== null && diff !== 0) && (<div className={"fs-6 fw-bold text-end " + (diff > 0 ? "text-success" : "text-danger")} style={{ width: "80px" }}>({diff > 0 ? "+" : ""}{Math.round(diff)}%)</div>)}
	    {(diff !== null && diff === 0) && (<div style={{ width: "80px" }}/>)}
	</div>
    );
}
